export const sq4m = {
  'images': [],
  'mainFeatures': [
    'Premium Nature Rubber with Nano Graphite Coating',
    'High Curved Windshield Available',
    'Patented Multi-functional Base Design'
  ],
  'material': [
    'Rubber: Premium Nature Rubber',
    'Steel: SK7',
    'Rivet: Steel Rivet',
    'Plastic (Spacer & Adapter): POM',
    'Plastic (Spoiler): PP+TPV'
  ],
  'featureIcons': ["02", "03", "07"],
  'otherFeatures': ["01", "02"],
  'specification': [
    { "inch": "13", "mm": "336", "width": "6", "thickness": "0.8" },
    { "inch": "14", "mm": "356", "width": "6", "thickness": "0.8" },
    { "inch": "15", "mm": "386", "width": "6", "thickness": "0.8" },
    { "inch": "16", "mm": "406", "width": "6", "thickness": "0.8" },
    { "inch": "17", "mm": "436", "width": "6", "thickness": "0.8" },
    { "inch": "18", "mm": "456", "width": "6", "thickness": "0.8" },
    { "inch": "19", "mm": "486", "width": "6", "thickness": "0.8" },
    { "inch": "20", "mm": "506", "width": "6", "thickness": "0.8" },
    { "inch": "21", "mm": "536", "width": "6", "thickness": "0.8" },
    { "inch": "22", "mm": "566", "width": "6", "thickness": "0.8" },
    { "inch": "23", "mm": "586", "width": "6", "thickness": "0.8" },
    { "inch": "24", "mm": "606", "width": "6", "thickness": "0.9" },
    { "inch": "26", "mm": "656", "width": "6", "thickness": "0.9" },
    { "inch": "28", "mm": "706", "width": "6", "thickness": "0.9" }
  ],
  'adapters': ['ehs', 'ehd', 'dpj', 'c0', 'c1-2', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c9', 'c10', 'e1']
}